// extracted by mini-css-extract-plugin
export default {"ohHovertab":"style_ohHovertab__BGCum","onSelectedtab":"style_onSelectedtab__TPUoR","numberAvatar":"style_numberAvatar__CNvR4"};